<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
 <v-card class="lighten-4 pa-3 ml-3" dark color="#181745" style="height:100%;">
   <v-select
          :items="items"
          filled
          dark
          label="Filter by"
          v-model="province"
          background-color="purple darken-2"
        ></v-select>
        <div v-if="loadingData" style="text-align: center; width: 100%;" class="pb-3">
          <v-progress-circular
                indeterminate
                color="purple"
                size="36"></v-progress-circular>
        </div>
    <div> 
      <div class="mb-5 pa-2" style="background-color: rgba(0,0,0,0.2);">
        <div class="mb-3">
          <span class="caption grey--text mr-1" style="font-weight: 300;">LAST UPDATED:</span>
          <span class="caption grey--text">{{lastupdated}}</span>
        </div> 
        <div v-if="latestNews !==''" class="caption white--text text--lighten-2" style="font-weight: 300;">{{latestNews}}</div>

        <!-- <div class="mt-2">
          <v-btn class="mr-4" dark block small color="pink darken-1" @click="openOmicron">
            <v-icon left>open_in_new</v-icon>Track Omicron Variant
          </v-btn>
      </div> -->
    
      </div>    
      <div class="subheading pa-1 pl-2" style="font-weight: 100; text-transform: uppercase;">
        Confirmed</div>
      <div>
        <v-row>
          <v-col cols="6" class="pl-5 pr-0">
            <span class="title mt-1 blue--text text--lighten-2" style="font-weight: 300; font-size: 26px !important;">{{getNumberDisplay(confirmed)}}</span>
          </v-col>
          <v-col v-if="confirmed_change != 0" cols="6" class="pt-0 text-center">
            <div v-if="confirmed_change > 0">
              <v-icon dark color="pink lighten-2" size="22" class="ml-0">arrow_drop_up</v-icon>
              <span class="subheading pink--text text--lighten-2" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(confirmed_change))}}</span>
            </div>
            <div v-if="confirmed_change < 0">
              <v-icon dark color="green" size="22" class="ml-0">arrow_drop_down</v-icon>
              <span class="subheading green--text" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(confirmed_change))}}</span>
            </div>            
            <div class="caption grey--text mt-1" style="font-weight: 300;">FROM PREVIOUS</div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="mt-4">
      <div class="subheading pa-1 pl-2" style="font-weight: 100; text-transform: uppercase;">
        Recovered</div>
      <div>
        <v-row>
          <v-col cols="6" class="pl-5 pr-0">
            <span class="title mt-1 green--text" style="font-weight: 300; font-size: 26px !important;">{{getNumberDisplay(recovered)}}</span>
          </v-col>
         <v-col v-if="recovered_change != 0" cols="6" class="pt-0 text-center">
            <div v-if="recovered_change < 0">
              <v-icon dark color="pink lighten-2" size="22" class="ml-0">arrow_drop_down</v-icon>
              <span class="subheading pink--text text--lighten-2" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(recovered_change))}}</span>
            </div>
            <div v-if="recovered_change > 0">
              <v-icon dark color="green" size="22" class="ml-0">arrow_drop_up</v-icon>
              <span class="subheading green--text" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(recovered_change))}}</span>
            </div>            
            <div class="caption grey--text mt-1" style="font-weight: 300;">FROM PREVIOUS</div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="mt-4">
      <div class="subheading pa-1 pl-2" style="font-weight: 100; text-transform: uppercase;">
        Deaths</div>
      <div>
        <v-row>
          <v-col cols="6" class="pl-5 pr-0">
            <span class="title mt-1 pink--text text--lighten-1" style="font-weight: 300; font-size: 26px !important;">{{getNumberDisplay(deaths)}}</span>
          </v-col>
         <v-col v-if="deaths_change != 0" cols="6" class="pt-0 text-center">
            <div v-if="deaths_change > 0">
              <v-icon dark color="pink lighten-2" size="22" class="ml-0">arrow_drop_up</v-icon>
              <span class="subheading pink--text text--lighten-2" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(deaths_change))}}</span>
            </div>
            <div v-if="deaths_change < 0">
              <v-icon dark color="green" size="22" class="ml-0">arrow_drop_down</v-icon>
              <span class="subheading green--text" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(deaths_change))}}</span>
            </div>            
            <div class="caption grey--text mt-1" style="font-weight: 300;">FROM PREVIOUS</div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="mt-4">
      <div class="subheading pa-1 pl-2" style="font-weight: 100; text-transform: uppercase;">
        Active</div>
      <div>
        <v-row>
          <v-col cols="6" class="pl-5 pr-0">
            <span class="title mt-1 orange--text text--lighten-1" style="font-weight: 300; font-size: 26px !important;">{{getNumberDisplay(active)}}</span>
          </v-col>
          <v-col v-if="active_change != 0" cols="6" class="pt-0 text-center">
            <div v-if="active_change > 0">
              <v-icon dark color="pink lighten-2" size="22" class="ml-0">arrow_drop_up</v-icon>
              <span class="subheading pink--text text--lighten-2" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(active_change))}}</span>
            </div>
            <div v-if="active_change < 0">
              <v-icon dark color="green" size="22" class="ml-0">arrow_drop_down</v-icon>
              <span class="subheading green--text" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(active_change))}}</span>
            </div>            
            <div class="caption grey--text mt-1" style="font-weight: 300;">FROM PREVIOUS</div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="mt-4">
      <div class="subheading pa-1 pl-2" style="font-weight: 100; text-transform: uppercase;">
        Tests in SA</div>
      <div>
        <v-row>
          <v-col cols="6" class="pl-5 pr-0">
            <span class="title mt-1 yellow--text" style="font-weight: 300; font-size: 26px !important;">{{getNumberDisplay(tests)}}</span>
          </v-col>
          <v-col v-if="tests_change != 0" cols="6" class="pt-0 text-center">
            <div v-if="tests_change > 0">
              <v-icon dark color="green" size="22" class="ml-0">arrow_drop_up</v-icon>
              <span class="subheading green--text" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(tests_change))}}</span>
            </div>
            <div v-if="tests_change < 0">
              <v-icon dark color="pink lighten-2" size="22" class="ml-0">arrow_drop_down</v-icon>
              <span class="subheading pink--text text--lighten-2" style="font-weight: 300;font-size: 18px !important;">{{getNumberDisplay(getChangeDisplay(tests_change))}}</span>
            </div>            
            <div class="caption grey--text mt-1" style="font-weight: 300;">FROM PREVIOUS</div>
          </v-col>
        </v-row>
      </div>
    </div>

    <div class="mt-4 mb-5">
      <div class="subheading pa-1 pl-2" style="font-weight: 100; text-transform: uppercase;">
        Vaccines in SA</div>
      <div>
        <v-row>
          <v-col cols="12" class="pl-5 pr-0">
            <span class="title mt-1" style="font-weight: 400; font-size: 26px !important; color: #05976e;">{{getNumberDisplay(vaccines)}}</span>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- <div class="mt-0">
      <div>
        <v-row>
          <v-col cols="12" class="ma-0 pa-0">
            <apexchart type="radialBar" height="150" :options="chartOptions" :series="series" />
          </v-col>
        </v-row>
      </div>
    </div> -->
    <!-- <div style="margin-top:40px;">
      <div class="subheading pa-1 pl-2" style="font-weight: 100; text-transform: uppercase;">
        Last Updated</div>
      <div>
        <v-row>
          <v-col cols="12" class="pl-5 pt-0">
            <span class="title grey--text" style="font-weight: 300; font-size: 18px !important;">{{lastupdated}}</span>
          </v-col>
        </v-row>
      </div>
    </div> -->

    <div class="mt-2">
      <v-btn class="mr-4" dark block small color="purple darken-1" @click="openAfrica">
        <v-icon left>open_in_new</v-icon>View Africa Dashboard
      </v-btn>
    </div>

    <!-- <div style="margin-top:20px;">
      <div class="mb-2">
        <span class="caption grey--text mr-1" style="font-weight: 300;">POWERED BY</span>
        <img src="../../public/assets/hydra.png" style="height: 20px; vertical-align: middle; cursor: pointer;" onclick="window.open('../../assets/COVID-19RiskManagementAwareness.pdf','_blank');">
      </div>
      <div>
        <span class="caption grey--text mr-1" style="font-weight: 300;">DATA SOURCES:</span>
        <a class="caption" href="https://www.gov.za/media-statements" target="_blank">gov.za</a>
        <span class="mr-2">&nbsp;</span>
        <a class="caption" href="https://www.nicd.ac.za/diseases-a-z-index/covid-19/" target="_blank">nicd.ac.za</a>
        <span class="mr-2">&nbsp;</span>
        <a class="caption" href="../../data/toupdate/sources.csv" target="_blank">other</a>
      </div>
      <div>
        <span class="caption grey--text mr-1" style="font-weight: 300;">LEGAL:</span>
        <a class="caption" href="./privacy.html" target="_blank">Privacy Policy</a>
        <span class="mr-2">&nbsp;</span>
        <a class="caption" href="#" @click="dialogDisclaimer = true">Disclaimer</a>
      </div>
      <div>
        <span class="caption grey--text mr-1" style="font-weight: 300;">© 2021 <a href="https://awarenesscompany.co.za" target="_blank">The Awareness Company</a>
        <div class="caption grey--text">All Rights Reserved.</div></span>
      </div>
    </div> -->
     <!-- <v-dialog v-model="dialogDisclaimer" max-width="70%" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title class="title purple darken-1 white--text">Disclaimer</v-card-title>
        <v-card-text>
          <div class="title mt-3">21 March 2020</div>
          <div class="body-1 mt-3">
            The information contained on the www.health.hydra.africa website (the "Service") is for general information purposes only. The Awareness Company assumes no responsibility for errors or omissions in the contents on the Service.
            <br/><br/>
            In no event shall The Awareness Company be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. The Awareness Company reserves the right to make additions, deletions, or modification to the contents on the Service at any time without prior notice. 
            <br/><br/>
            The www.health.hydra.africa website may contain links to external websites that are not provided or maintained by or in any way affiliated with The Awareness Company. Please note that The Awareness Company does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
            <br/><br/>
            The www.health.hydra.africa website is not in any way affiliated with any official government or health organisations.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogDisclaimer = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
 </v-card>
</template>

<script>
  import Papa from 'papaparse'

  export default {
    name: 'Overview',
    data: () => ({
      items: ['National','Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 'Mpumalanga', 'North West', 'Northern Cape', 'Western Cape'],
      province: "National",
      confirmed: 0,
      confirmed_change: 0,
      recovered: 0,
      recovered_change: 0,
      deaths: 0,
      deaths_change: 0,
      active: 0,
      active_change: 0,
      tests: 0,
      tests_change: 0,
      vaccinated: 0,
      vaccines: 0,
      series: [],
      chartOptions: {
        colors: ["#20E647"],
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: "60%",
              background: "transparent"
            },
            track: {
              show: true,
              //background: '#122039',
              opacity: 0.3
            },
            dataLabels: {
              name: {
                offsetY: -20,
                color: "#9e9e9e",
                fontSize: "12px"
              },
              value: {
                offsetY: 0,
                color: "#05976e",
                fontSize: "24px",
                show: true
              }
            }
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            gradientToColors: ["#87D4F9"],
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: "round"
        },
        labels: ["Vaccinated"]
      },
      lastupdated: "",
      dialogDisclaimer: false,
      latestNews: "",
      loadingData: true
    }),
    watch: {
      province: function(val) {
        //emit the filter
        this.$emit("filterProvince", val)

        //post the GA
        gtag('event', 'filter', {
          'event_category' : val,
          'send_to': 'UA-161523063-1'
        });
      }
    },
    methods: {
      loadCases(data, provinceDisplay) {
        //clear data
        this.confirmed = 0
        this.confirmed_change = 0
        this.recovered = 0
        this.recovered_change = 0
        this.deaths = 0
        this.deaths_change = 0
        this.active = 0
        this.active_change = 0

        //check no data
        if(data.length === 0) {
          return
        }

        //first get the distinct dates
        var dates = [];
        dates = Array.from(new Set(data.map(summ => summ.date))).map(date => {
          return date;
        });

        //find the date of the last entry
        var lastCaseDate = dates[dates.length - 1]
        var prevCaseDate = dates[dates.length - 2]

        //set the region filter
        var filterRegion = "National"
        //check if only one prov selected
        if(provinceDisplay && provinceDisplay !== "") {
          filterRegion = provinceDisplay
        }

        //last and prev entries
        var matchLast = data.find(c => c.date === lastCaseDate && c.region === filterRegion)
        var matchPrev = data.find(c => c.date === prevCaseDate && c.region === filterRegion)

        //CONFIRMED
        this.confirmed = matchLast.confirmed*1

        //change from last case date        
        this.confirmed_change = (this.confirmed - matchPrev.confirmed*1)

        //RECOVERED
        this.recovered = matchLast.recovered*1

        //change from last case date
        this.recovered_change = (this.recovered - matchPrev.recovered*1)

        //DEATHS
        this.deaths = matchLast.deceased*1

        //change from last case date
        this.deaths_change = (this.deaths - matchPrev.deceased*1)

        //ACTIVE
        this.active = this.confirmed - this.recovered - this.deaths

        //change from last case date
        //subtract death and recovered changes from the confirmed
        this.active_change = this.confirmed_change - this.deaths_change - this.recovered_change  

        //TESTS
        var match = data.find(c => c.date === lastCaseDate && c.region === "National")
        this.tests = match.tests*1

        //change from last case date
        var match = data.find(c => c.date === prevCaseDate && c.region === "National")
        this.tests_change = (this.tests - match.tests*1)

        //VACCINATED
        var vmatch = data.find(c => c.date === lastCaseDate && c.region === "National")
        this.vaccinated = vmatch.vaccinated*1
        this.vaccines = vmatch.vaccines*1

        //calc perc of population
        var perc = (this.vaccinated/59308690) * 100
        var vacsperc = parseFloat(perc.toFixed(2))
        this.series = [vacsperc]

        this.loadingData = false
      },
      loadLastUpdated(data) {
        this.lastupdated = this.$moment(data[0].last_updated).format('LLL')
        this.latestNews = data[0].news
      },
      getChangeDisplay(change) {
        return Math.abs(change)
      },
      getNumberDisplay(number) {
        return number.toLocaleString('en').replace(/\,/g, ' ')   
      },
      openAfrica() {
        window.open('./africa','_blank');

        //post the GA
        gtag('event', 'africa', {
          'event_category' : 'open',
          'send_to': 'UA-161523063-1'
        });
      },
      openOmicron() {
        window.open('./omicron.html','_blank');

        //post the GA
        gtag('event', 'omicron', {
          'event_category' : 'open',
          'send_to': 'UA-161523063-1'
        });
      }
    }
  }
</script>